<template>
  <div
    class="dropdown-element"
    :class="{ disable }"
    :style="{ maxHeight: `${targetY}px` }"
   
  >
    <div ref="element">
      <slot />
    </div>
  </div>
</template>
<script setup lang="ts">
  const props = defineProps({
    expanded: {
      type: Boolean,
      default: false,
    },
    disable: {
      type: Boolean,
      default: false,
    },
  })
  const element = ref(null)
  const { height } = useElementSize(element)
  const targetY = computed(() => (props.expanded ? height.value : 0))
</script>
<style lang="scss" scoped>
  .dropdown-element {
    &.disable {
      max-height: none !important;
    }
    &:not(.disable) {
      overflow: hidden;
      transition: max-height var(--dropdown-ani-time) cubic-bezier(0.5, 0, 0.5, 1);
    }
  }
</style>
